import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.jsx';
import { homePathForUser } from '../utils/roles.js';

/**
 * @param {{ userId: number, label?: string, className?: string, size?: 'sm' | undefined }} props
 */
export function ViewAsUserButton({ userId, label = 'View as', className = '', size = 'sm' }) {
  const { startImpersonation, impersonationLoading } = useAuth();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);

  const onClick = async () => {
    setBusy(true);
    try {
      const viewed = await startImpersonation(userId);
      navigate(homePathForUser(viewed), { replace: true });
    } catch {
      // error surfaced via auth if needed
    } finally {
      setBusy(false);
    }
  };

  const btnClass = ['btn', size === 'sm' ? 'btn-outline-secondary btn-sm' : 'btn-outline-secondary', className]
    .filter(Boolean)
    .join(' ');

  return (
    <button
      type="button"
      className={btnClass}
      onClick={() => void onClick()}
      disabled={busy || impersonationLoading}
    >
      {busy || impersonationLoading ? 'Opening…' : label}
    </button>
  );
}
